import { render, staticRenderFns } from "./SocialSecurityData.vue?vue&type=template&id=43363ade&scoped=true"
import script from "./SocialSecurityData.vue?vue&type=script&lang=js"
export * from "./SocialSecurityData.vue?vue&type=script&lang=js"
import style0 from "./SocialSecurityData.vue?vue&type=style&index=0&id=43363ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43363ade",
  null
  
)

export default component.exports